import type { AppSettings } from '@/lib/types';
import { DEFAULT_CURRENCY } from '@/lib/money';

export const DEFAULT_APP_SETTINGS: AppSettings = {
  id: 'main',
  currency: DEFAULT_CURRENCY,
  createdAt: '',
  updatedAt: '',
};
